export interface ITaskFromServer {
    id: number,
    name: string,
    data: Object,
    progress: number,
    status: TaskStatuses,
    type: number,
    updatedAt: string,
    createdAt: string
}

export type TaskStatuses = "CREATED" | "IN_PROCESS" | "COMPLETED" | "PARTIAL_COMPLETED" | "FAILED" | "WAITING" | "CANCELLED"

interface ITaskStatusesList {
    [key: number | string]: TaskStatuses 
}

export const TaskStatusesList: ITaskStatusesList = Object.freeze({
    1: "CREATED",
    2: "IN_PROCESS",
    3: "COMPLETED",
    4: "FAILED",
    5: "WAITING",
    6: "PARTIAL_COMPLETED",
    7: "CANCELLED"
})